<template>
    <v-container>
        <v-row>
            <v-col cols=12 class="text-center display-1">
                Sign Up
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols=12>
                <v-container>
                    <v-row justify="center">
                        <v-col lg=4 cols=12 class="text-center">
                            <v-form>
                                <v-text-field placeholder="Name" v-model="name" :rules="[rules.required]" autofocus></v-text-field>
                                <v-text-field placeholder="Email" type="email" v-model="username" :rules="[rules.required]"></v-text-field>
                                <v-text-field placeholder="Password" :type="show ? 'text' : 'password'" v-model="password" :rules="[rules.required, rules.min]" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" @click:append="show = !show"></v-text-field>
                                <v-text-field placeholder="Confirm Password" :type="show ? 'text' : 'password'" v-model="confirmedPassword" :rules="[rules.required, rules.min]" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" @click:append="show = !show"></v-text-field>
                                <v-btn color="primary" @click="submit" :loading="loading" block>
                                    Submit
                                </v-btn>
                            </v-form>
                        </v-col>    
                    </v-row>
                </v-container>
            </v-col>
            <v-col lg=4 cols=12 v-if="showError">
                <v-alert type="error" v-model="showError">{{ errorMsg }}</v-alert>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import rp from "request-promise-native";

export default {
    // Prevent the user from accessing the dashboard if they are not logged in.
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.$store.state.token.length > 0) {            
                next("/dashboard");
            } else {
                next();
            }
        })
    },
    data() {
        return {
            show: false,
            rules: {
                required: value => !!value || "Required",
                min: v => v.length >= 8 || "Min 8 characters",
            },
            loading: false,
            showError: false,
            errorMsg: ""
        }
    },
    computed: {
        username: {
            get() {
                return this.$store.state.username;
            },
            set(val) {
                this.$store.commit("setUsername", val);
            }
        },
        name: {
            get() {
                return this.$store.state.name;
            },
            set(val) {
                this.$store.commit("setName", val);
            }
        },
        password: {
            get() {
                return this.$store.state.password;
            },
            set(val) {
                this.$store.commit("setPassword", val);
            }
        },
        confirmedPassword: {
            get() {
                return this.$store.state.confirmedPassword;
            },
            set(val) {
                this.$store.commit("setConfirmedPassword", val);
            }
        },
    },
    methods: {
        async submit() {
            // Set the loading animation
            this.loading = true;

            // Custom form checking to determine whether or not to show the loading symbol
            if (this.rules.required(this.name) !== true || this.rules.required(this.username) !== true || (this.rules.required(this.password) !== true || this.rules.min(this.password) !== true) || (this.rules.required(this.confirmedPassword) !== true || this.rules.min(this.confirmedPassword) !== true)) {
                this.loading = false;
                return;
            }

            // To access the Vue component later
            let self = this;
            
            // Setup the request
            let options = {
                method: "POST",
                uri: `${process.env.VUE_APP_HOST}/users`,
                body: {
                    name: self.$store.state.name,
                    email: self.$store.state.username,
                    password: self.$store.state.password
                },
                json: true
            };

            // Submit the request
            try {
                // Sign the user up
                await rp(options);
                // Mark the user as signed up
                self.$store.commit("setSignedUp");

                // If successful, log the user in
                options = {
                method: 'POST',
                uri: `${process.env.VUE_APP_HOST}/users/login`,
                body: {
                    email: self.$store.state.username,
                    password: self.$store.state.password
                },
                json: true // Automatically stringifies the body to JSON
                };

                try {
                    const loggedIn = await rp(options);
                    // Clear the password
                    self.$store.commit("clearPassword");

                    // Set the token
                    self.$store.commit("setToken", loggedIn.token);

                    // Set the name
                    self.$store.commit("setName", loggedIn.user.name);

                    // Move to another route
                    self.$router.push({name: "Create Car"});
                } catch (e) {
                    console.log("Error: ", e);
                    this.loading = false;
                    
                }
                
            } catch (e) {
                this.errorMsg = e.error.errors.email.message;
                this.showError = true;
                
            }

        }
    }
}
</script>